import react from 'react'
import { Button, FormControl } from "react-bootstrap"

export default function FilterComponent(props) {
    const { text, setText, resetFilter } = props

    return (
        <div style={{display:"flex"}}>
            <FormControl
                size='sm'
                style={{ marginBottom: "8px" }}
                type="text"
                id="filter-text-box"
                placeholder="Filter..."
                value={text}
                onChange={(e) => setText(e.target.value)}
            />

            <Button size='sm' style={{ marginLeft: "8px", height: "80%", width:"125px" }} onClick={() => {
                resetFilter()
                setText('')

            }}>Reset Filter</Button>
        </div>
    )
}